/**
 * Генерация HTML одной строки истории поиска.
 * Зависит от render-helpers.js (_safeEscape, _formatLangLabel, _formatDate).
 */

// i18n helper for history item labels
function _getItemText(key, fallback) {
  var lang = (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
  var texts = (window.LANG_TEXTS && window.LANG_TEXTS[lang]) || {};
  return texts[key] || fallback;
}

/**
 * Генерирует HTML одной строки истории.
 * opts: { depth, rootId, isRoot, hasChildren, activeChain, totalDescendants }
 */
function _renderHistoryItemRow(item, opts) {
  var displayTerm = item.displayTerm || item.term || item.query || '';
  var query = item.query || item.term || '';
  var showQueryHint = displayTerm && query && displayTerm.toLowerCase() !== query.toLowerCase();

  var termFull = displayTerm;
  var langLabel = window._formatLangLabel(item.lang);
  var dateStr = window._formatDate(item.timestamp);

  var depth = opts.depth || 0;
  var rootId = opts.rootId || '';
  var isRoot = !!opts.isRoot;
  var hasChildren = !!opts.hasChildren;
  var inActiveChain = opts.activeChain && opts.activeChain[item.id];
  var isActive = (window.CURRENT_HISTORY_ID === item.id);

  var classes = ['search-history-item'];
  if (isRoot) classes.push('is-root');
  if (hasChildren) classes.push('has-children');
  if (inActiveChain) classes.push('in-active-chain');
  if (isActive) classes.push('is-active');
  if (opts.lastInBranch) classes.push('last-in-branch');

  // continuations — массив depth-уровней, на которых предок ещё имеет siblings ниже.
  // Для каждого рисуем вертикальную линию-продолжение через всю высоту строки.
  var continuations = opts.continuations || [];

  var html = '';
  html += '<div class="' + classes.join(' ') + '"';
  html += ' data-id="' + window._safeEscape(item.id || '') + '"';
  html += ' data-parent-id="' + window._safeEscape(item.parentId || '') + '"';
  html += ' data-root-id="' + window._safeEscape(rootId) + '"';
  html += ' data-depth="' + depth + '"';
  html += ' data-term="' + window._safeEscape(query) + '"';
  html += ' data-display-term="' + window._safeEscape(displayTerm) + '"';
  html += ' data-lang="' + window._safeEscape(item.lang || '') + '"';
  html += ' data-search-type="' + window._safeEscape(item.searchType || '') + '"';
  html += ' data-term-index="' + window._safeEscape(item.termIndex || '') + '"';
  html += ' data-term-guid="' + window._safeEscape(item.termGuid || '') + '"';
  html += ' style="--hi-depth: ' + depth + ';"';
  html += '>';

  // Все линии через DOM-элементы.
  // Класс 'ap' (active-path) ставится на конкретные span-коннекторы, которые лежат
  // на пути от корня до активного элемента. Это даёт непрерывную жирную линию.
  var activeContinuations = opts.activeContinuations || {};

  if (!isRoot && depth > 0) {
    var connDepth = depth - 1;
    // hi-conn-v: вертикальная линия на уровне родителя, соединяющая сиблингов.
    // Случай split: элемент в chain, parent в chain, НО нет позднего chain-сиблинга
    // и элемент НЕ last → верхняя половина (до L-bend) толстая, нижняя тонкая.
    var selfEndpoint = inActiveChain && opts.parentInActiveChain && !opts.laterSiblingInChain;
    if (selfEndpoint && !opts.lastInBranch) {
      // Split: верхняя часть (0→50%) толстая, нижняя (50%→100%) тонкая
      html += '<span class="hi-conn-v ap hi-conn-v-top" style="--c-depth: ' + connDepth + ';"></span>';
      html += '<span class="hi-conn-v hi-conn-v-bottom" style="--c-depth: ' + connDepth + ';"></span>';
    } else {
      var vAp = (opts.laterSiblingInChain || selfEndpoint) ? ' ap' : '';
      html += '<span class="hi-conn-v' + vAp + '" style="--c-depth: ' + connDepth + ';"></span>';
    }
    // hi-conn-h толстый если САМ ЭЛЕМЕНТ в active chain (горизонтальный шаг к нему)
    var hAp = inActiveChain ? ' ap' : '';
    html += '<span class="hi-conn-h' + hAp + '" style="--c-depth: ' + connDepth + ';"></span>';
  }

  // Мостик parent→child: вертик. линия от 50% parent до bottom.
  // Толстый только если путь продолжается вниз (есть ребёнок в chain).
  // На корне не рисуем — корень связан с детьми через toggle/chevron.
  if (hasChildren && !isRoot) {
    var ccAp = opts.hasChildInChain ? ' ap' : '';
    html += '<span class="hi-child-conn' + ccAp + '" style="--c-depth: ' + depth + ';"></span>';
  }

  for (var ci = 0; ci < continuations.length; ci++) {
    var vlAp = activeContinuations[continuations[ci]] ? ' ap' : '';
    html += '<span class="hi-vline' + vlAp + '" style="--vl-depth: ' + continuations[ci] + ';"></span>';
  }

  // Toggle для ветки с детьми (только у корня)
  if (isRoot && hasChildren) {
    html += '<button type="button" class="search-history-toggle" aria-label="' + window._safeEscape(_getItemText('btn_toggle_branch', 'Toggle branch')) + '" data-toggle-root="' + window._safeEscape(rootId) + '">';
    html += '<i class="bi bi-chevron-right search-history-toggle-caret" aria-hidden="true"></i>';
    html += '</button>';
  } else {
    html += '<span class="search-history-indent" aria-hidden="true"></span>';
  }

  html += '<div class="search-history-item-content">';
  html += '<div class="search-history-term-block">';
  html += '<div class="search-history-term" title="' + window._safeEscape(displayTerm) + '"><span>' + window._safeEscape(displayTerm) + '</span></div>';
  if (showQueryHint) {
    html += '<div class="search-history-query-hint" title="' + window._safeEscape(query) + '">'
      + '<i class="bi bi-search search-history-query-icon" aria-hidden="true"></i> '
      + window._safeEscape(query) + '</div>';
  }
  html += '</div>';
  // Уровень прояснения — иконка + число, левый нижний угол, при hover (CSS)
  if (depth > 0) {
    html += '<span class="search-history-depth-label">'
      + '<i class="bi bi-diagram-3" aria-hidden="true"></i>'
      + depth + '</span>';
  }
  // Кнопка удаления — видима только при hover (CSS)
  var _delLabel = _getItemText('btn_delete', 'Delete');
  html += '<button type="button" class="search-history-delete" aria-label="' + window._safeEscape(_delLabel) + '" data-delete-id="' + window._safeEscape(item.id || '') + '" title="' + window._safeEscape(_delLabel) + '">'
    + '<i class="bi bi-trash" aria-hidden="true"></i>'
    + '</button>';
  html += '</div>';
  html += '</div>';
  return html;
}

window._renderHistoryItemRow = _renderHistoryItemRow;
